import { render, staticRenderFns } from "./LatePostingBadge.vue?vue&type=template&id=474ecdf4"
import script from "./LatePostingBadge.vue?vue&type=script&lang=js"
export * from "./LatePostingBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports